<template>
    <div>
        <div class="about" :class="{ active: animate }">
      <div class="aboutHeader">
        <img
          src="../../../../assets/manufacturing/manufacturingOne.jpg"
          alt="aboutHeader"
          id="aboutHeaderImage"
        />
      </div>
      <div class="top-left">
        <h1 class="drop-from-top">
           CCS in Manufacturing 
        </h1>
        <p class="drop-from-bottom">
            Building Partnerships, Powering Progress: Uniting Manufacturing Excellence
        </p>
      </div>
    </div>
    </div>
</template>

<script src="./first.js"></script>
<style src="./first.css"></style>